import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as actionCreators from "../actions/actionCreators.js";


import Dashboard from "../components/Dashboard";


function mapStateToProps(state){
	//console.log("Connecting state", state.series);
	return {
		lang: state.data.lang,
		logo: state.data.logo,
		rank: state.data.userInfo.rank,
		justLogged: state.data.justLogged,
		cachedAPIs: state.data.cachedData,
		auth: state.data.auth,
	}
}

function mapDispatchToProps(dispatch){
	return bindActionCreators(actionCreators, dispatch);
}


const DashboardContainer = connect(mapStateToProps, mapDispatchToProps)(Dashboard);

export default DashboardContainer;


// WEBPACK FOOTER //
// ./src/containers/DashboardContainer.js